module.exports = __webpack_public_path__ + "static/media/TimerButton.30e4e27a.svg";